export const PageStatuses = {
  ready: 'ready',
  pending: 'pending',
  succeed: 'succeed',
  failed: 'failed'
} as const;

export type PageStatus = typeof PageStatuses[keyof typeof PageStatuses];
